// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { action } from 'mobx';

import { UserService } from '../../services';
import { LoggerService } from '../../services/LoggerService';
import { UserStore } from './UserStore';

export class UserActions {
  constructor(private readonly userStore: UserStore) {}

  @action getUserProfile = () => {
    return UserService.getUserProfile()
      .then((user) => {
        if (user.data) {
          this.userStore.setUser(user.data);
          this.userStore.setUserAuthenticated(true);
        } else {
          // Don't log errors on public pages
          const isPublicRoute = window.location.pathname.startsWith('/signup');
          if (!isPublicRoute) {
            LoggerService.error('No user data received');
          }
          throw new Error('no user');
        }
      })
      .catch((err) => {
        // Don't log 401 errors on public pages (expected behavior)
        const isPublicRoute = window.location.pathname.startsWith('/signup');
        const isAuthError = err?.response?.status === 401;

        if (!isPublicRoute || !isAuthError) {
          LoggerService.error('Failed to load user profile', {
            status: err?.response?.status,
            error: err?.message,
          });
        }

        this.userStore.setUserAuthenticated(false);
      });
  };
}
